{
  "version": 1,
  "headline": "Pick your plan.",
  "subheadline": "Simple pricing for every size team.",
  "billing": {
    "yearlyDiscountLabel": "Save 20%",
    "yearlyDiscountHint": "on a yearly subscription"
  },
  "enterpriseCallout": {
    "title": "Enterprise",
    "description": "Get advanced security (SOC 2 reports), priority support, standard legal agreement & more.",
    "ctaLabel": "Contact Sales",
    "ctaHref": "mailto:support@emailperfect.io?subject=Email%20Perfect%20Enterprise"
  },
  "tiers": [
    {
      "id": "free",
      "name": "Basic",
      "tagline": "Basic features for individuals",
      "priceMonthly": 0,
      "priceYearly": 0,
      "cta": { "label": "Join for free", "type": "auth" },
      "highlight": false,
      "cardFeaturesIntro": "Everything you need to start building emails.",
      "cardHighlights": [
        "250 AI credits / mo",
        "Up to 3 projects",
        "2 Editors, 5 Viewers",
        "Email Perfect elements library",
        "5 hosted images per email",
        "25 preflight checks / mo",
        "25 exports / mo",
        "Email support"
      ]
    },
    {
      "id": "core",
      "name": "Plus",
      "tagline": "For growing teams",
      "priceMonthly": 19,
      "priceYearly": 190,
      "cta": { "label": "Get Plus", "type": "auth" },
      "highlight": true,
      "cardFeaturesIntro": "More seats, checks, and collaboration for growing teams.",
      "cardHighlights": [
        "2,500 AI credits / mo",
        "Unlimited projects",
        "5 Editors, 20 Viewers",
        "Custom components per project",
        "10 hosted images per email",
        "50 preflight checks / mo",
        "10-step version history",
        "Email + Chat support"
      ]
    },
    {
      "id": "pro",
      "name": "Pro",
      "tagline": "For power teams",
      "priceMonthly": 49,
      "priceYearly": 490,
      "cta": { "label": "Get Pro", "type": "auth" },
      "highlight": false,
      "cardFeaturesIntro": "Full power for teams that ship email at scale.",
      "cardHighlights": [
        "5,000 AI credits / mo",
        "Unlimited projects & roles",
        "Custom components per team",
        "Unlimited hosted images",
        "100 preflight checks / mo",
        "Unlimited link tracking",
        "20-step version history",
        "Chat and live support"
      ]
    },
    {
      "id": "enterprise",
      "name": "Enterprise",
      "tagline": "For organizations at scale",
      "priceLabel": "Ask",
      "cta": {
        "label": "Contact us",
        "type": "mailto",
        "href": "mailto:support@emailperfect.io?subject=Email%20Perfect%20Enterprise"
      },
      "highlight": false,
      "cardFeaturesIntro": "Security, SSO, and org-wide control at scale.",
      "cardHighlights": [
        "10,000 AI credits / mo",
        "Workspaces for your org",
        "Components across all teams",
        "Unlimited hosted images",
        "Unlimited preflight checks",
        "SSO for your organization",
        "Public preview for anyone",
        "Unlimited version history"
      ]
    }
  ],
  "featureGroups": [
    {
      "label": "Core",
      "features": ["AI", "Projects", "Roles", "Workspaces"]
    },
    {
      "label": "Design & content",
      "features": ["Components", "Hosted images", "Custom Google Fonts"]
    },
    {
      "label": "Workflow",
      "features": ["History", "Undos", "Preflight check", "Link tracking", "Send test email", "Exports"]
    },
    {
      "label": "Support & security",
      "features": ["Support", "SSO", "Public preview"]
    }
  ],
  "features": [
    {
      "label": "AI",
      "values": {
        "free": "250 credits / mo",
        "core": "2,500 credits / mo",
        "pro": "5,000 credits / mo",
        "enterprise": "10,000 credits / mo"
      }
    },
    {
      "label": "Projects",
      "values": { "free": "3", "core": "Unlimited", "pro": "Unlimited", "enterprise": "Unlimited" }
    },
    {
      "label": "Roles",
      "values": {
        "free": "2 Editors, 5 Viewers",
        "core": "5 Editors, 20 Viewers",
        "pro": "Unlimited",
        "enterprise": "Unlimited"
      }
    },
    {
      "label": "Workspaces",
      "values": { "free": "No", "core": "No", "pro": "No", "enterprise": "Yes" }
    },
    {
      "label": "Components",
      "values": {
        "free": "Email Perfect elements",
        "core": "Per Project",
        "pro": "Per Team",
        "enterprise": "Use across all teams"
      }
    },
    {
      "label": "Hosted images",
      "values": { "free": "5 per email", "core": "10 per email", "pro": "Unlimited", "enterprise": "Unlimited" }
    },
    {
      "label": "History",
      "values": {
        "free": "No history",
        "core": "10 step history",
        "pro": "20 step history",
        "enterprise": "Unlimited history"
      }
    },
    {
      "label": "Undos",
      "values": {
        "free": "Basic (5 undos)",
        "core": "Full (for the session)",
        "pro": "Full (for the session)",
        "enterprise": "Full (for the session)"
      }
    },
    {
      "label": "Custom Google Fonts",
      "values": { "free": "Yes", "core": "Yes", "pro": "Yes", "enterprise": "Yes" }
    },
    {
      "label": "Preflight check",
      "values": {
        "free": "25 / mo",
        "core": "50 / mo",
        "pro": "100 / mo",
        "enterprise": "Unlimited"
      }
    },
    {
      "label": "Link tracking",
      "values": {
        "free": "1 data, 1 UTM",
        "core": "3 each",
        "pro": "Unlimited",
        "enterprise": "Unlimited"
      }
    },
    {
      "label": "Send test email",
      "values": { "free": "25 / mo", "core": "50 / mo", "pro": "100 / mo", "enterprise": "Unlimited" }
    },
    {
      "label": "Exports",
      "values": { "free": "25 / mo", "core": "50 / mo", "pro": "100 / mo", "enterprise": "Unlimited" }
    },
    {
      "label": "Support",
      "values": {
        "free": "Email",
        "core": "Email + Chat",
        "pro": "Chat and live (via scheduler)",
        "enterprise": "Chat and live (via scheduler)"
      }
    },
    {
      "label": "SSO",
      "values": { "free": "—", "core": "—", "pro": "—", "enterprise": "Yes" }
    },
    {
      "label": "Public preview",
      "values": {
        "free": "No",
        "core": "Yes (viewers)",
        "pro": "Yes (viewers)",
        "enterprise": "Yes (anyone)"
      }
    }
  ]
}
